import React from 'react'


const Test = () => (
	<div id="ipsum">
		<div>
			<h1>Videmus igitur ut conquiescere ne infantes quidem possint.</h1>

			<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. <b>Quaerimus enim finem bonorum.</b> Illud urgueam, non intellegere eum quid sibi dicendum sit, cum dolorem summum malum esse dixerit. Quid est enim aliud esse versutum? Quid est enim aliud esse versutum? Gerendus est mos, modo recte sentiat. <code>Duo Reges: constructio interrete.</code> Quid est, quod ab ea absolvi et perfici debeat? <a href="http://loripsum.net/" target="_blank">Itaque ad tempus ad Pisonem omnes.</a> Tanti autem aderant vesicae et torminum morbi, ut nihil ad eorum magnitudinem posset accedere. Quod non faceret, si in voluptate summum bonum poneret. Et hunc idem dico, inquieta sed ad virtutes et ad vitia nihil interesse. </p>

			<dl>
				<dt><dfn>Beatum, inquit.</dfn></dt>
				<dd>Quod idem cum vestri faciant, non satis magnam tribuunt inventoribus gratiam.</dd>
				<dt><dfn>Bork</dfn></dt>
				<dd>At enim sequor utilitatem.</dd>
				<dt><dfn>Bork</dfn></dt>
				<dd>Nam si propter voluptatem, quae est ista laus, quae possit e macello peti?</dd>
				<dt><dfn>Hunc vos beatum;</dfn></dt>
				<dd>Estne, quaeso, inquam, sitienti in bibendo voluptas?</dd>
			</dl>


			<ul>
				<li>Deinceps videndum est, quoniam satis apertum est sibi quemque natura esse carum, quae sit hominis natura.</li>
				<li>Sumenda potius quam expetenda.</li>
				<li>Qui autem esse poteris, nisi te amor ipse ceperit?</li>
				<li>Bonum negas esse divitias, praeposìtum esse dicis?</li>
			</ul>


			<ol>
				<li>Esse enim quam vellet iniquus iustus poterat inpune.</li>
				<li>Haec bene dicuntur, nec ego repugno, sed inter sese ipsa pugnant.</li>
				<li>Intrandum est igitur in rerum naturam et penitus quid ea postulet pervidendum;</li>
				<li>Haec igitur Epicuri non probo, inquam.</li>
			</ol>


			<blockquote cite="http://loripsum.net">
				Sin eam, quam Hieronymus, ne fecisset idem, ut voluptatem illam Aristippi in prima commendatione poneret.
			</blockquote>


			<h4>Mihi vero, inquit, placet agi subtilius et, ut ipse dixisti, pressius.</h4>

			<p>Quae duo sunt, unum facit. Non enim iam stirpis bonum quaeret, sed animalis. Quid ergo aliud intellegetur nisi uti ne quae pars naturae neglegatur? </p>

			<h3>Est, ut dicis, inquit;</h3>

			<p>Nulla profecto est, quin suam vim retineat a primo ad extremum. Videsne, ut haec concinant? Nemo nostrum istius generis asotos iucunde putat vivere. <i>Qua tu etiam inprudens utebare non numquam.</i> Virtutibus igitur rectissime mihi videris et ad consuetudinem nostrae orationis vitia posuisse contraria. Est enim effectrix multarum et magnarum voluptatum. <a href="http://loripsum.net/" target="_blank">Non autem hoc: igitur ne illud quidem.</a> <i>Quae sequuntur igitur?</i> </p>

			<p>Bork Tibi hoc incredibile, quod beatissimum. Non igitur potestis voluptate omnia dirigentes aut tueri aut retinere virtutem. Murenam te accusante defenderem. Expressa vero in iis aetatibus, quae iam confirmatae sunt. Cum audissem Antiochum, Brute, ut solebam, cum M. <a href="http://loripsum.net/" target="_blank">Tum mihi Piso: Quid ergo?</a> <code>Egone quaeris, inquit, quid sentiam?</code> Hanc ergo intuens debet institutum illud quasi signum absolvere. Consequens enim est et post oritur, ut dixi. </p>

			<pre>Istud quidem, inquam, optime dicis, sed quaero nonne tibi
			faciendum idem sit nihil dicenti bonum, quod non rectum
			honestumque sit, reliquarum rerum discrimen omne tollenti.

			Dicam, inquam, et quidem discendi causa magis, quam quo te
			aut Epicurum reprehensum velim.
			</pre>


			<h5>Quibusnam praeteritis?</h5>

			<p><i>Sed ego in hoc resisto;</i> Videamus igitur sententias eorum, tum ad verba redeamus. <code>Res enim concurrent contrariae.</code> Vide ne ista sint Manliana vestra aut maiora etiam, si imperes quod facere non possim. <code>Avaritiamne minuis?</code> <a href="http://loripsum.net/" target="_blank">Negare non possum.</a> <code>Sed potestne rerum maior esse dissensio?</code> Sin eam, quam Hieronymus, ne fecisset idem, ut voluptatem illam Aristippi in prima commendatione poneret. Nunc haec primum fortasse audientis servire debemus. <i>Nam ista vestra: Si gravis, brevis;</i> Ergo omni animali illud, quod appetiti positum est in eo, quod naturae est accommodatum. Nunc haec primum fortasse audientis servire debemus. </p>

			<h1>Test Heading 1</h1>
			<h2>Test Heading 2</h2>
			<h3>Test Heading 3</h3>
			<h4>Test Heading 4</h4>
			<h5>Test Heading 5</h5>
			<p>A test paragraph, let's add some stuff - a <b>bold</b> text, some <i>italics script</i>, <strong>strong (whatever that is)</strong>, and finally <em>ephasised</em>. We can also try silly things like <strong><em>strong emphasis</em></strong>, and <b><i>bold italics</i></b>, but that would be very <mark>dumb</mark>.</p>
			<p>But here's another paragraph just for fun</p>
			
			<h1 className='titillium'>Test Heading Titillium Web</h1>
			<h1 className='karla'>Test Heading Karla</h1>
			<h1 className='anton'>Test Heading Anton</h1>
			<h1 className='work'>Test Heading Work Sans</h1>
			<h1 className='crimson'>Test Heading Crimson Text</h1>
			<h1 className='amatic'>Test Heading Amatic SC</h1>
			<h1 className='racing'>Test Heading Racing Sans One</h1>
			<h1 className='londrina'>Test Heading Londrina Solid</h1>
			<h1 className='boogaloo'>Test Heading Boogaloo</h1>
			<h1 className='staatliches'>Test Heading Staatliches</h1>
			<h1 className='broscoi'>Test Heading Broscoi Regular</h1>
			<h1 className='edge'>Test Heading Edge Of The Galaxy</h1>
			<h1 className='nt'>Test Heading NT Wagner</h1>
			<h1 className='storybook'>Test Heading Storybook Regular</h1>
			<h1 className='sounds'>Test Heading Sounds Different</h1>

			<h1 className='upper titillium'>Test Heading Titillium Web</h1>
			<h1 className='upper karla'>Test Heading Karla</h1>
			<h1 className='upper anton'>Test Heading Anton</h1>
			<h1 className='upper work'>Test Heading Work Sans</h1>
			<h1 className='upper crimson'>Test Heading Crimson Text</h1>
			<h1 className='upper amatic'>Test Heading Amatic SC</h1>
			<h1 className='upper racing'>Test Heading Racing Sans One</h1>
			<h1 className='upper londrina'>Test Heading Londrina Solid</h1>
			<h1 className='upper boogaloo'>Test Heading Boogaloo</h1>
			<h1 className='upper staatliches'>Test Heading Staatliches</h1>
			<h1 className='upper broscoi'>Test Heading Broscoi Regular</h1>
			<h1 className='upper edge'>Test Heading Edge Of The Galaxy</h1>
			<h1 className='upper nt'>Test Heading NT Wagner</h1>
			<h1 className='upper storybook'>Test Heading Storybook Regular</h1>
			<h1 className='upper sounds'>Test Heading Sounds Different</h1>

			<h1 className='lower titillium'>Test Heading Titillium Web</h1>
			<h1 className='lower karla'>Test Heading Karla</h1>
			<h1 className='lower anton'>Test Heading Anton</h1>
			<h1 className='lower work'>Test Heading Work Sans</h1>
			<h1 className='lower crimson'>Test Heading Crimson Text</h1>
			<h1 className='lower amatic'>Test Heading Amatic SC</h1>
			<h1 className='lower racing'>Test Heading Racing Sans One</h1>
			<h1 className='lower londrina'>Test Heading Londrina Solid</h1>
			<h1 className='lower boogaloo'>Test Heading Boogaloo</h1>
			<h1 className='lower staatliches'>Test Heading Staatliches</h1>
			<h1 className='lower broscoi'>Test Heading Broscoi Regular</h1>
			<h1 className='lower edge'>Test Heading Edge Of The Galaxy</h1>
			<h1 className='lower nt'>Test Heading NT Wagner</h1>
			<h1 className='lower storybook'>Test Heading Storybook Regular</h1>
			<h1 className='lower sounds'>Test Heading Sounds Different</h1>


		</div>
	</div>
)

export default Test
